import { each, max, map } from "lodash";

declare const jQuery: any;
const $ = jQuery;

const config = Object.freeze({
	dfWait: 4000,
	minWait: 1000,
	minItemsPerGroup: 1,
	dfItemsPerGroup: [
		{ minWindowWidth: 500, nItems: 2 },
		{ minWindowWidth: 768, nItems: 3 },
		{ minWindowWidth: 1200, nItems: 4 }
	]
});

export interface ItemsPerGroupSetting
{
	minWindowWidth: number;
	nItems: number;
}

export function getItemsPerGroupDataFromWrapAttr($wrap, dfItemsPerGroup = config.dfItemsPerGroup)
{
	const attrVal: string = $wrap.attr("data-slider-items-per-group")
	if (!attrVal)
	{
		return dfItemsPerGroup;
	}
	return map(attrVal.split(/\s*\,\s*/g), (widthNumItemsString: string) => {
		const widthNumItemsSubstrings: string[] = widthNumItemsString.split(/\s*\:\s*/g);
		return {
			minWindowWidth: parseInt(widthNumItemsSubstrings[0], 10),
			nItems: parseInt(widthNumItemsSubstrings[1], 10)
		};
	});
}

export function getWaitValueFromWrapAttr($wrap, dfWait: number = config.dfWait, minWait: number = config.minWait): number
{
	const strValue: string = $wrap.attr("data-slider-wait");
	if (!strValue)
	{
		return dfWait;
	}
	const numValue: number = parseFloat(strValue);
	if (numValue <= 0)
	{
		return 0;
	}
	return numValue ? max([minWait, numValue * 1000]) : dfWait;
}

export function getItemsPerGroup($window, itemsPerGroupSettings): number
{
	let itemsPerGroup: number = config.minItemsPerGroup;
	const w: number = $window.outerWidth();
	each(itemsPerGroupSettings, cfg => {
		if (w < cfg.minWindowWidth)
		{
			return false;
		}
		itemsPerGroup = cfg.nItems;
	});
	return itemsPerGroup;
}

export function itemsPerGroupObjectToHtmlAttr(itemsPerGroup: ItemsPerGroupSetting[]): string
{
	return map(itemsPerGroup, (setting: ItemsPerGroupSetting) => {
		return setting.minWindowWidth + ":" + setting.nItems;
	}).join(",");
}
